module.exports = __webpack_public_path__ + "static/img/11.ed6f7de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/11.jpg
// module id = JlnA
// module chunks = 1